<template>
  <div>
    <form id="formSiteSetupFAQUpload" @change="clearErrors()" class="d-flex flex-column" v-on:submit.prevent="uploadFAQfile">
      <div class="d-flex flex-column tab-card-form">
        <div class="element-info">
          <div class="row align-items-center">
            <div v-if="this.mobile" class="col-sm-8">
              <div class="element-info-with-icon justify-content-center">
                <div class="element-info-text text-center">
                  <h5 class="element-inner-header">FAQ Upload</h5>
                  <div class="element-inner-desc">Here you can upload FAQ files.</div>
                </div>
              </div>
            </div>
            <div v-else class="col-sm-8">
              <div class="element-info-with-icon">
                <div class="element-info-icon">
                  <fontAwesomeIcon :icon="['fas', 'file-upload']" size="2x" />
                </div>
                <div class="element-info-text ml-5">
                  <h5 class="element-inner-header">FAQ Upload</h5>
                  <div class="element-inner-desc">Here you can upload FAQ files.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="project-box d-flex flex-column">
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header">Upload a FAQ</h5>
              <h5 v-else class="py-2 text-center">Upload a FAQ</h5>
            </div>
          </div>
          <div class="row new-faq-form">
              <div class="col-md">
                <label>File Name</label>
                <b-form-input v-model="faqFileName" placeholder="HowToChangeSomething"></b-form-input>
              </div>
              <div class="col-md">
                <label>Description</label>
                <b-form-input v-model="description" placeholder="What's inside of this document?"></b-form-input>
              </div>
              <div class="col-md">
                <label>Role</label>
                <b-select class="custom-select col" v-model="v3_level_id">
                  <option v-for="r in roles" :value="r.id">{{ r.name }}</option>
                </b-select>
              </div>
              <div class="col-md">
                <label>File</label>
                <b-form-file
                  v-model="faqBrowseFile"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                ></b-form-file>
                <div class="mt-1">Selected file: {{ faqBrowseFile ? faqBrowseFile.name : '' }}</div>
              </div>
          </div>
          <transition name="fade">
            <ResponseInfo v-if="getResponseInfo.responseName == 'siteSetupFaq'" class="mt-3"/>
          </transition>
          <button v-if="!this.mobile" :disabled="!faqBrowseFile || !faqFileName" class="btn btn-primary my-3 align-self-end" type="submit" value="submit">Upload</button>
          <button v-else :disabled="!faqBrowseFile || !faqFileName" class="btn btn-secondary my-3 align-self-end" type="submit" value="submit">Upload</button>
        </div>
        <div class="project-box pb-3">
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header" >FAQ files</h5>
              <h5 v-else class="py-2 pt-4 text-center" >FAQ files</h5>
            </div>
          </div>
          <div v-if="this.faqs" class="row">
            <div class="col-lg-6 col-sm-6">
              <div class="el-tablo centered padded-v">
                <div class="value">{{ this.faqs.length }}</div>
                <div class="label">uploaded FAQs</div>
              </div>
            </div>
            <div class="col-lg-6 col-sm-6">
              <div class="el-tablo centered padded-v">
                <div class="value text-primary">{{ 20 - this.faqs.length }}</div>
                <div class="label">FAQ uploads left</div>
              </div>
            </div>
          </div>
        </div>
        <div class="project-box">
          <div v-if="!this.faqs.length" class="row justify-content-center">
            <p class="text-muted">No FAQ files had been uploaded so far</p>
          </div>
          <div>
            <b-table v-if="this.faqs.length" striped hover :items="faqRows" :fields="fields" show-empty>
              <template slot="[date_added]" slot-scope="data">
                <span>{{ data.item.date_added | humanReadable }}</span>
              </template>
              <template v-slot:cell(role)="data">
                <select class="custom-select" v-model="data.item.v3_level_id">
                  <option v-for="r in roles" :value="r.id">{{ r.name }}</option>
                </select>
              </template>
              <template v-slot:cell(description)="data">
                <span><input class="form-control" type="text" v-model="data.item.description" /></span>
              </template>
              <template v-slot:cell(actions)="data">
                <b-button size="sm" @click="saveChanges(data.item)" class="mr-1">
                  Save
                </b-button>
                <router-link :to="{ name: 'website_faq', params: { id: data.item.id, filename: data.item.filename }}" target="_blank">
                  <b-button size="sm" class="mr-1">PREVIEW</b-button>
                </router-link>
                <b-button size="sm" @click="info('Delete FAQ', data.item.filename, data.item.id, $event.target)" class="mr-1">
                  DELETE
                </b-button>
              </template>
            </b-table>
          </div>
        </div>
        <b-modal class="modal fade bd-example-modal-sm show" :id="infoModal.id" :title="infoModal.title" footer-class="border-top" :header-bg-variant="'secondary'" hide-backdrop @hide="resetInfoModal">
          <template slot="modal-header" slot-scope="{ close }">
            <h5 class="modal-title text-light">{{ infoModal.title }}</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">x</span></button>
          </template>
          <template slot="default">
            <p class="text-center"><span>You are about to delete</span> <b class="d-block pt-2" style="font-weight: 600;">{{ infoModal.filename}}</b></p>
          </template>
          <template slot="modal-footer" slot-scope="{ ok, cancel }">
            <b-button variant="danger" @click="deleteFAQ(infoModal.faqId, infoModal.filename), ok()">
              Delete
            </b-button>
            <b-button variant="secondary" @click="cancel()">
              Cancel
            </b-button>
          </template>
        </b-modal>
        <div v-if="this.infoModal.filename" class="modal-backdrop show"></div>
      </div>
    </form>
    <AbsoluteNotification :notification="notification" />
  </div>
</template>

<script>
/* Modal had been added to avoid accidental file deletion */
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ValidationErrors from '@/components/ValidationErrors.vue'
import moment from 'moment'
import axios from "../../axios";
import AbsoluteNotification from "../AbsoluteNotification";

export default{
  name: 'SiteSetupFAQUpload',
  components: {
    AbsoluteNotification,
    ResponseInfo,
    ValidationErrors
  },
  data() {
    return {
      faqBrowseFile: null,
      faqFileName: '',
      description: '',
      v3_level_id: null,
      fields: [
        {key: 'filename', label: 'File name'},
        {key: 'description', label: 'Description'},
        {key: 'role', label: 'Role'},
        {key: 'date_added', label: 'Uploaded at'},
        {key: 'actions', label: 'actions'}
      ],
      faqRows: [],
      infoModal: {
        id: 'info-modal-faq',
        title: '',
        filename: '',
        faqId: ''
      },
      mobile: window.innerWidth <= 700,
      notification: null,
    }
  },
  created() {
    this.loadFaqs();

    window.addEventListener('resize', () => {
      this.mobile = window.innerWidth <= 700
    })
  },
  computed: {
    ...mapGetters(['allTemplateDetails', 'getUserDetails', 'getIsNewsnet', 'getFAQs', 'getResponseInfo', 'getUserLevel']),
    faqs: {
      get() {
        return this.$store.getters.getFAQs
      }
    },
    roles: {
      get() {
        let roles = this.$store.getters["faqStore/getRoles"];
        if (!this.v3_level_id) {
          this.v3_level_id = roles.length > 0 ? roles[0].id : null;
        }
        return roles;
      },
    },
  },
  methods: {
    uploadFAQfile() {
      let formData = new FormData();

      formData.append('faqBrowseFile', this.faqBrowseFile)
      formData.append('faqFileName', this.faqFileName)
      formData.append('v3_level_id', this.v3_level_id)
      formData.append('description', this.description)

      this.$store.dispatch('uploadFAQ', formData)
      .then(() => {
        this.faqBrowseFile = ''
        this.faqFileName = ''
        this.description = ''
      }).finally(() => {
        this.loadFaqs()
      })
    },
    clearErrors() {
      //clearing the error message when we change the input
      this.$store.commit('setValidationErrors', [])
    },
    info(title, filename, faqId, footerClass, button) {
      this.infoModal.title = title
      this.infoModal.filename = filename
      this.infoModal.faqId = faqId
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.filename = ''
        this.infoModal.faqId = ''
    },
    deleteFAQ(faqId, filename) {
      this.$store.dispatch('deleteFAQfile',{
        faqId: faqId,
        filename: filename
      })
      .then(() => {
        this.$store.dispatch('getFAQs', {
          userLevel: this.getUserLevel
        }).then(() => {
          if(this.faqs.length){
            this.faqRows = this.faqs
          }
        })
      })
    },
    loadFaqs() {
      this.$store.dispatch('getFAQs', {
        userLevel: this.getUserLevel
      }).then(() => {
        if (this.faqs.length) {
          this.faqRows = this.faqs
        }
      })
    },
    saveChanges(file) {
      axios().post("/faqFileUpdate", file).then(() => {
        this.loadFaqs()
        this.notify("Changes saved successfully!");
      })
    },
    notify(text) {
      this.notification = text;
      setTimeout(() => {
        this.notification = null;
      }, 3000);
    },
  },
  filters: {
    humanReadable: function(date) {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-card-form{
  min-width: 70%;
}
.pretext{
  display: flex;
  align-items: center;
  justify-content: center;
}
.pretext-span{
  width: 100%;
  white-space: normal;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.new-faq-form {
  label {
    width: 100%;
  }
}
</style>
